import React, { useState, useEffect, useMemo } from 'react';
import { Dialog, DialogContent, DialogTitle } from '@material-ui/core';
import styles from 'assets/styles/training.module.scss';
import stylesTraining from './Training.module.scss';
import { imageBasePath } from 'constants';
import { ConfirmationDialog } from 'shared_elements';
import { useHistory } from 'react-router-dom';
import GenerateQuizCard from './GenerateQuizCard';
import { CustomButton } from 'shared_ui_components';
import { useGetAIStatusPerModule } from '../Training.queries';
import {
  useCreateQuestionsMutation,
  useGetTrainingModuleIngestion,
} from '../assessment/ModuleBased/ModuleAssessment.queries';
import { useModuleAssessmentsAIStore } from '../assessment/ModuleBased/ObtainWithAI/ModuleAssessmentAI.store';
import { useGetFF } from '@fstack-tech/ff_react_module';

const GenerateQuiz = (props) => {
  const {
    open,
    activeModule,
    setStartAsssesmentSetup = null,
    setIsQuiz = null,
    setGenerateQuiz = null,
    setIsEditQuiz = null,
    isFFEnabledAIModuleBasedAssessment = true,
    setIsAIGenerate = null,
    isAIGenerate = false,
  } = props;
  const [addSuccess, setAddSuccess] = useState(false);
  const [moduleAIActive, setModuleAIActive] = useState(false);
  const { data = {}, isFetching: isLoadingAIStatusModuleAssessment } = useGetAIStatusPerModule({
    module_uuid: activeModule?.uuid,
    number_id: activeModule?.id,
    enabled: open,
  });
  const { isEnabled: ff_learning_paths } = useGetFF({ flag_id: 'learning_paths' });
  const { mutate } = useCreateQuestionsMutation();
  const questionsPerModule = useModuleAssessmentsAIStore((state) => state?.questionsPerModule);
  const moduleQuestionsAI = questionsPerModule.filter(
    (module) => module.module_uuid === activeModule.id
  );
  const enabled = useMemo(
    () => open && isFFEnabledAIModuleBasedAssessment,
    [open, isFFEnabledAIModuleBasedAssessment]
  );
  const { data: trainingModuleIngestion = {}, isFetching: isLoadingAIIngestion } =
    useGetTrainingModuleIngestion({
      module_uuid: activeModule?.id,
      enabled: enabled,
    });
  useEffect(() => {
    setModuleAIActive(
      Array.isArray(trainingModuleIngestion) &&
        trainingModuleIngestion.some((a) => a?.status === 'SUCCEEDED')
    );
  }, [trainingModuleIngestion]);
  useEffect(() => {
    if (
      moduleQuestionsAI[0]?.status === 'SUCCEEDED' ||
      moduleQuestionsAI[0]?.status === 'PARTIAL_SUCCESS'
    ) {
      setStartAsssesmentSetup(true);
      setIsQuiz(true);
      setGenerateQuiz(false);
      setIsEditQuiz(false);
      setIsAIGenerate(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [moduleQuestionsAI]);

  let history = useHistory();

  const handleClose = () => {
    props.handleClose();
  };

  const AIGenerate = () => {
    const module_uuid = activeModule?.id;
    const body = {
      retry: data?.data?.module_with_ai ? true : false,
      first_time: !data?.data?.module_with_ai,
    };
    mutate(
      { module_uuid, body, regenerate: false },
      {
        onSuccess: () => {
          setStartAsssesmentSetup(true);
          setIsQuiz(true);
          setGenerateQuiz(false);
          setIsEditQuiz(false);
          setIsAIGenerate(true);
        },
      }
    );
  };

  return (
    <>
      <div>
        <Dialog
          open={open}
          onClose={props.handleClose}
          scroll={'paper'}
          className={`dialog ${styles.addNewModule}`}
        >
          <DialogTitle id="add-video-title">
            {!activeModule.module_assessment_enable ? 'Generate Quiz' : 'Manage Quiz'}
            <img
              src={imageBasePath + 'close_gray.svg'}
              alt="close icon"
              className="modalCloseIcon"
              onClick={handleClose}
            />
          </DialogTitle>
          <DialogContent>
            <div className={stylesTraining.generateQuizContainer}>
              <div className={stylesTraining.generateQuizBody}>
                <GenerateQuizCard
                  image={'sparkle_st.svg'}
                  title={'AI Assisted'}
                  subTitle={'Generate questions using the power of AI'}
                  actionButton={data?.data?.module_with_ai ? 'Re-Generate' : 'Generate'}
                  // comingSoon={!isFFEnabledAIModuleBasedAssessment}
                  onClick={AIGenerate}
                  disabled={!moduleAIActive || isLoadingAIIngestion}
                />
                <GenerateQuizCard
                  image={'pen_st.svg'}
                  title={'Manual'}
                  subTitle={`Use our spreadsheet template to bulk import your questions`}
                  actionButton={'Import'}
                  onClick={() => {
                    setStartAsssesmentSetup(true);
                    setIsQuiz(true);
                    setGenerateQuiz(false);
                    setIsEditQuiz(false);
                  }}
                />
              </div>
              {activeModule.module_assessment_enable && (
                <CustomButton
                  className={'tertiaryBtn'}
                  onClick={() => {
                    setStartAsssesmentSetup(true);
                    setIsQuiz(true);
                    setGenerateQuiz(false);
                    setIsEditQuiz(true);
                  }}
                >
                  Edit Existing Questions
                </CustomButton>
              )}
            </div>
          </DialogContent>
        </Dialog>
      </div>
      <ConfirmationDialog
        open={addSuccess}
        title={
          <>
            <strong>{module?.title}</strong> skill set has been added!
          </>
        }
        description={`You can go ahead and start adding ${
          ff_learning_paths ? 'resources' : 'content'
        } to this ${ff_learning_paths ? 'skill set' : 'module'}`}
        acceptText={`Add ${ff_learning_paths ? 'Resources' : 'Content'}`}
        rejectText="Will do it later"
        image={imageBasePath + 'module_added_success.svg'}
        handleClose={() => setAddSuccess(false)}
        handleSubmit={() => history.push(`/training/${module?.uuid}`)}
      />
    </>
  );
};

export default GenerateQuiz;
